import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./JustPay.module.css";
import Important from "../../assets/images/Important.svg";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 430,
    xl: 430,
    md: 430,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: "20px",
  zIndex: 999999,
};

function CancelModalForJustPay(props: any) {
  const { open, onClose, noButtonClick, yesButtonClick } = props;
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "999999" }}
      >
        <Box sx={style}>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <img src={Important} />
              </div>
              <div onClick={onClose} className={styles.closeModalButton}>
                <CloseIcon />
              </div>
            </div>
            <div className={styles.modalTitle}>Criteria to Apply Loan</div>
            <div className={styles.modalDes}>
              Students can now apply for a personal loan with simple eligibility
              criteria — a minimum CIBIL score of 650, loan amounts starting
              from ₹10,000 up to ₹4,00,000 (based on the CIBIL score), and
              tenure options subject to selection.
            </div>
            <div className={styles.modalDes}>
              The loan is instant, with approvals and disbursement happening
              within 10–15 minutes. Once the Institute clicks on Apply Loan, a
              unique QTM link will be sent directly to the registered mobile
              number via SMS and to the email of student to complete the
              application.
            </div>
            {/* <div className={styles.buttonSection}>
              <button onClick={noButtonClick} className={styles.noButton}>
                Cancel
              </button>
              <button onClick={yesButtonClick} className={styles.yesButton}>
                Confirm
              </button>
            </div> */}
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default CancelModalForJustPay;
